<template>
  <div class="card">
    <div class="card-header">
      <h4 class="mb-0">
        {{ $t('PQTOffersView.qiymtTklifiMqaissi') }}
      </h4>
    </div>
    <div class="row pl-5 align-end">
      <b-button
        class="col-4 mr-5 ml-4"
        @click="showOnlyPriceComparison = true"
      >
        {{ $t('newRFQRequest.yalnzQiymtMqayissi') }}
      </b-button>
      <b-button
        class="col-4 ml-5"
        @click="showDetailedView = true"
      >
        {{ $t('newRFQRequest.traflMqayis') }}
      </b-button>
    </div>

    <!-- Detailed Comparison Modal -->
    <DetailedComparisonModal
      :ranked-offers="rankedOffers"
      :visible="showDetailedView"
      :offers="offers"
      :get-parsed-prices="getParsedPrices"
      :get-product="getProduct"
      :get-requirement-reply="getRequirementReply"
      :get-tech-specification="getTechSpecification"
      :get-parsed-prices-extras="getParsedPricesExtras"
      :start-conversation="startConversation"
      :export-results-detailed-price="exportResultsDetailedPrice"
      :is-photo="isPhoto"
      :request_id="request.id"
      :get-photo="getPhoto"
      @update:visible="showDetailedView = $event"
      @confirm="handleCustomOk"
      @refreshData="handleRefreshData"
    />

    <!-- Price Comparison Modal -->
    <PriceComparisonModal
      :ranked-offers="rankedOffers"
      :visible="showOnlyPriceComparison"
      :only-price-comparison-data="onlyPriceComparisonData"
      :companies="companies"
      :export-results-only-price="exportResultsOnlyPrice"
      @update:visible="showOnlyPriceComparison = $event"
      @confirm="handleCustomOk"
    />

    <div
      v-for="o in rankedOffers"
      :key="o.id"
      class="offer-card mb-4"
    >
      <hr class="dashed">
      <div class="row ">
        <div class="col-md-6 ">
          <strong class="ml-1">{{ o.requestUser.company.name }} <span
            v-if="o.rejected"
            class="text-danger"
          >(Rədd edilib)</span></strong><br>
          <StarRatingView
            :count="o.requestUser.company.supplyRateCount"
            :total="o.requestUser.company.supplyRateTotal"
            @click.prevent="openCompanyRatingStatisticPopup = o.requestUser.company.id"
          />
        </div>
        <div class="col-md-6 text-left text-md-right">
          <strong class="badge bg-primary lead p-2 mr-2">
            {{ $t('PQTOffersView.ototalpriceAzn', {totalPrice: o.totalPrice}) }}
          </strong>
          <br>
          <em class="mr-2">(toplam)</em>
        </div>
      </div>

      <!-- Product Table -->
      <div
        class="row"
        :class="o.rejected ? 'offer-rejected' : ''"
      >
        <div class="col-md-12 mm">
          <table class="table table-responsive-md  table-fixed mt-3">
            <thead>
              <tr>
                <th>Məhsul adı</th>
                <th>Məhsulun qiyməti</th>
                <th>ƏDV 18%</th>
                <th>Cəm</th>
                <th>Global Sıra</th> <!-- New column header -->
              </tr>
            </thead>
            <tbody>
              <template v-for="item in o.products">
                <!-- Main Product Row -->
                <tr>
                  <td class="product-name">
                    <strong>{{ item.product.name }}</strong>
                  </td>
                  <td>
                    {{ item.price }} AZN x {{ item.product.count }} {{ item.product.unit }}
                  </td>
                  <td v-if="item.vatAmount">
                    {{ (item.vatAmount * item.product.count).toFixed(2) }} AZN
                  </td>
                  <td v-else>
                    -
                  </td>
                  <td>
                    {{ ((item.price + item.vatAmount) * item.product.count).toFixed(2) }} AZN
                  </td>
                  <td>
                    {{ item.globalRank || '-' }}
                  </td>
                </tr>

                <!-- Alternative Offer Row (only if it exists) -->
                <tr v-if="item.alternativeOffer">
                  <td class="text-primary">
                    <small>{{ item.alternativeOffer.name }} (Alternativ)</small>
                  </td>
                  <td class="text-primary">
                    {{ item.alternativeOffer.price }} AZN x {{ item.product.count }} {{ item.product.unit }}
                  </td>
                  <td
                    v-if="item.alternativeOffer.isVatPayer"
                    class="text-primary"
                  >
                    {{ (item.alternativeOffer.vatAmount * item.product.count).toFixed(2) }} AZN
                  </td>
                  <td v-else>
                    -
                  </td>
                  <td class="text-primary">
                    {{ (item.alternativeOffer.total * item.product.count).toFixed(2) }} AZN
                  </td>
                  <td class="text-primary">
                    {{ item.alternativeOffer.globalRank || '-' }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Offer Totals -->
      <div class="mt-3 ml-1">
        <strong>Toplam (Əsas təklif):</strong> {{ o.mainTotal }} AZN
        <span class="badge bg-danger ml-3">{{ o.mainRank }}. yer</span>
        <br>
        <div v-if="o.alternativeTotal>0">
          <strong>Toplam (Alternativ təklif):</strong> {{ o.alternativeTotal }} AZN
          <span class="badge text-white bg-primary ml-3">{{ o.alternativeRank }}. yer</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StarRatingView from "@/pages/scc/utils/StarRatingView.vue"
import {
  exportRequestResultDetailed,
  exportRequestResultPrice,
  startNewOfferConversation
} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto,} from "@/repositories/Utils";
import DetailedComparisonModal from "@/pages/scc/request/DetailedComparisonModal.vue";
import PriceComparisonModal from "@/pages/scc/request/PriceComparisonModal.vue";

export default {
  name: 'PQTOffersView',
  components: {
    PriceComparisonModal,
    DetailedComparisonModal,
    StarRatingView,
  },
  props: {
    request: {
      type: Object,
      default() {
        return {}
      }
    },
    offers: {
      type: Array,
      default() {
        return []
      }
    },
    products: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      showOnlyPriceComparison: false,
      showDetailedView: false
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token
    }),
    onlyPriceComparisonData() {
      // Assume flatOffers is an array of objects built from all offers
      // Each flatOffer might be:
      // { productId, companyName, main: { price, vat, total }, alternative: { price, vat, total } }
      const flatOffers = this.offers.flatMap(offer => {
        const companyName = offer.requestUser.company.name;
        const parsed = this.parsePrices(offer.prices); // should return { prices: [...] }
        const prices = parsed.prices || [];
        return prices.map(item => {
          const product = this.getProductById(item.product) || {};
          const count = product.count || 1;
          const mainPrice = parseFloat(item.price) || 0;
          const isVatPayer = (item.isVatPayer === 'true');
          const vatPerUnit = isVatPayer ? this.calculateVAT(mainPrice) : 0;
          let alternative = null;
          if (item.alternativeOffer) {
            const altPrice = parseFloat(item.alternativeOffer.price) || 0;
            const altVatPerUnit = isVatPayer ? this.calculateVAT(altPrice) : 0;
            alternative = {
              price: altPrice * count,
              vat: altVatPerUnit * count,
              total: (altPrice + altVatPerUnit) * count,
            };
          }
          return {
            productId: item.product,
            companyName,
            main: {
              price: mainPrice * count,
              vat: vatPerUnit * count,
              total: (mainPrice + vatPerUnit) * count,
            },
            alternative,
          };
        });
      });

      // Group offers by productId
      const grouped = flatOffers.reduce((acc, offer) => {
        if (!acc[offer.productId]) {
          const product = this.getProductById(offer.productId) || {};
          acc[offer.productId] = {Məhsullar: product.name, companies: {}};
        }
        acc[offer.productId].companies[offer.companyName] = offer;
        return acc;
      }, {});

      // Optionally, add a total row if needed...
      return Object.values(grouped);
    },
    companies() {
      if (!this.onlyPriceComparisonData.length) return [];
      const [firstRow] = this.onlyPriceComparisonData;
      return Object.keys(firstRow).filter(key => key !== 'Məhsullar');
    },
    rankedOffers() {
      const rankedOffers = this.rankOfferTotals();
      const globalRanking = this.calculateGlobalProductRanking();

      return this.offers.map((offer) => {
        const totals = this.calculateTotals(offer);

        // 2) For each product row in this offer
        const productRanks = this.getPQTPrices(offer).map((item) => {
          const productId = item.product.id || item.product;

          // Find the main entry for this product in globalRanking
          const mainEntry = globalRanking[productId].find(
              (e) => e.offerId === offer.id && e.isAlternative === false
          );
          const mainGlobalRank = mainEntry ? mainEntry.globalRank : null;

          // If there's an alternative, find its rank
          if (item.alternativeOffer) {
            const altEntry = globalRanking[productId].find(
                (e) => e.offerId === offer.id && e.isAlternative === true
            );
            // Attach it directly so your template can use `item.alternativeOffer.globalRank`
            item.alternativeOffer.globalRank = altEntry ? altEntry.globalRank : null;
          }

          // Attach the main rank
          item.globalRank = mainGlobalRank;

          return item;
        });

        return {
          ...offer,

          products: productRanks, // Restore product details
          mainTotal: totals.totalMainPrice,
          alternativeTotal: totals.totalAlternativePrice,
          selectedTotal: totals.totalSelectedPrice,
          mainRank: rankedOffers.find((o) => o.offerId === offer.id)?.mainRank,
          alternativeRank: rankedOffers.find((o) => o.offerId === offer.id)?.alternativeRank,
          offerTechSpecification: this.getParsedPricesExtras(offer).techSpecification, // ← Added this line!
        };
      });
    }

  },

  emits: ['openCompanyRatingStatisticPopup'],
  methods: {
    rankOfferTotals() {
      const offersWithTotals = this.offers.map((offer) => {
        const totals = this.calculateTotals(offer);
        return {
          offerId: offer.id,
          mainTotal: totals.totalMainPrice,
          alternativeTotal: totals.totalAlternativePrice,
          selectedTotal: totals.totalSelectedPrice
        };
      });

      // Only include items with a total > 0
      const combinedTotals = offersWithTotals.flatMap((item) => {
        const arr = [];
        if (item.mainTotal > 0) {
          arr.push({ offerId: item.offerId, total: item.mainTotal, type: 'main' });
        }
        if (item.alternativeTotal > 0) {
          arr.push({ offerId: item.offerId, total: item.alternativeTotal, type: 'alternative' });
        }
        return arr;
      });

      combinedTotals.sort((a, b) => a.total - b.total);
      combinedTotals.forEach((item, index) => {
        item.rank = index + 1;
      });

      offersWithTotals.forEach((offer) => {
        const mainItem = combinedTotals.find(
            (item) => item.offerId === offer.offerId && item.type === 'main'
        );
        offer.mainRank = mainItem ? mainItem.rank : undefined;
        const alternativeItem = combinedTotals.find(
            (item) => item.offerId === offer.offerId && item.type === 'alternative'
        );
        offer.alternativeRank = alternativeItem ? alternativeItem.rank : undefined;
      });

      return offersWithTotals;
    },
    handleCustomOk() {
      this.showOnlyPriceComparison = false; // Optionally close the modal after action
      this.showDetailedView = false;
    },
    getProduct(productId) {
      return this.products.find(product => product.id === productId) || {};
    },

    getParsedPrices(offer) {
      try {
        return JSON.parse(offer.prices).prices || [];
      } catch (error) {
        console.error("Failed to parse prices:", error);
        return [];
      }
    },
    handleRefreshData() {
      // Re-emit the event upward to Request.vue
      this.$emit("refreshData");
    },
    getParsedPricesExtras(offer) {
      try {
        const extras = JSON.parse(offer.prices).extras || {};
        extras.isVatPayer = extras.isVatPayer === 'true'; // Convert to boolean
        return extras;
      } catch (error) {
        console.error("Failed to parse prices extras:", error);
        return {};
      }
    },

    getTechSpecification(offer, pId) {
      return this.getParsedPrices(offer).find(p => p.product === pId);
    },

    getRequirementReply(priceDetail, requirementId) {
      const requirementDetail = priceDetail.reqDetails.find(detail => detail.id === requirementId);
      return requirementDetail ? requirementDetail.detail : 'No reply';
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    parsePrices(pricesJSON) {
      try {
        return JSON.parse(pricesJSON);
      } catch (e) {
        return {};
      }
    },

    getPQTPrices(offer) {
      const prices = this.getParsedPrices(offer);

      // Collect product prices for ranking
      const productPrices = prices.map((item) => ({
        productId: item.product,
        isVatPayer: item.isVatPayer,
        isSelected: item.isSelected,
        totalPrice: item.price + (item.isVatPayer === 'true' ? this.calculateVAT(item.price) : 0),
        alternativeTotal: item.alternativeOffer
            ? item.alternativeOffer.price + (item.isVatPayer ? this.calculateVAT(item.alternativeOffer.price) : 0)
            : null,
      }));

      // Rank main prices
      const mainRanked = [...productPrices].sort((a, b) => a.totalPrice - b.totalPrice);
      mainRanked.forEach((item, index) => (item.rank = index + 1));

      // Rank alternative prices
      const alternativeRanked = [...productPrices]
          .filter((item) => item.alternativeTotal !== null)
          .sort((a, b) => a.alternativeTotal - b.alternativeTotal);
      alternativeRanked.forEach((item, index) => (item.alternativeRank = index + 1));

      return prices.map((item) => {
        const productPrice = productPrices.find((p) => p.productId === item.product);
        const vatAmount = item.isVatPayer === 'true' ? this.calculateVAT(item.price) : 0;
        const totalPrice = item.price + vatAmount;
        const isVatPayer = item.isVatPayer;
        let alternativeOffer = null;
        if (item.alternativeOffer) {

          const altVatAmount = item.isVatPayer === 'true' ? this.calculateVAT(item.alternativeOffer.price) : 0;
          alternativeOffer = {
            name: item.alternativeOffer.productName,
            price: item.alternativeOffer.price,
            techSpecs: item.alternativeOffer.techSpecs,
            isVatPayer: item.isVatPayer,
            isSelected: item.alternativeOffer.isSelected,
            vatAmount: altVatAmount,
            total: item.alternativeOffer.price + altVatAmount,
            alternativeRank: productPrice.alternativeRank,
          };
        }

        return {
          product: this.getProductById(item.product),
          price: item.price,
          isVatPayer: isVatPayer === 'true',
          isSelected: item.isSelected,
          vatAmount,
          totalPrice,
          rank: productPrice.rank,
          alternativeOffer,
        };
      });
    },

    calculateGlobalProductRanking() {
      const globalRanking = {};

      // Loop through all offers
      this.offers.forEach((offer) => {
        // getParsedPrices(offer) => array of { product, price, isVatPayer, alternativeOffer? }
        const prices = this.getParsedPrices(offer);

        prices.forEach((item) => {
          const productId = item.product;

          // Initialize array for this product if not exists
          if (!globalRanking[productId]) {
            globalRanking[productId] = [];
          }

          // 1) MAIN entry
          const mainTotalPrice =
              item.price + (item.isVatPayer === 'true' ? this.calculateVAT(item.price) : 0);

          globalRanking[productId].push({
            offerId: offer.id,
            isAlternative: false,
            totalPrice: mainTotalPrice,
          });

          // 2) ALTERNATIVE entry (if it exists)
          if (item.alternativeOffer) {
            const altPrice = item.alternativeOffer.price;
            const altTotalPrice =
                altPrice + (item.isVatPayer === 'true' ? this.calculateVAT(altPrice) : 0);

            globalRanking[productId].push({
              offerId: offer.id,
              isAlternative: true,
              totalPrice: altTotalPrice,
            });
          }
        });
      });

      // For each product, sort the entries by totalPrice and assign a globalRank using dense ranking.
      for (const productId in globalRanking) {
        // Sort in ascending order (cheapest first)
        globalRanking[productId].sort((a, b) => a.totalPrice - b.totalPrice);

        // Dense ranking: assign same rank to equal prices
        let currentRank = 1;
        globalRanking[productId][0].globalRank = currentRank;

        for (let i = 1; i < globalRanking[productId].length; i++) {
          if (globalRanking[productId][i].totalPrice === globalRanking[productId][i - 1].totalPrice) {
            globalRanking[productId][i].globalRank = currentRank;
          } else {
            currentRank++;
            globalRanking[productId][i].globalRank = currentRank;
          }
        }
      }

      return globalRanking;
    },


    calculateVAT(price) {
      return parseFloat((price * 0.18).toFixed(2)); // 18% VAT
    },
    calculateTotals(offer) {
      const products = this.getPQTPrices(offer);
      // Main total: Sum all main product prices
      const mainTotal = products.reduce((sum, item) => {
        return sum + ((item.price + item.vatAmount) * item.product.count);
      }, 0);

      // Check if any product has an alternative offer
      const hasAlternativeOffer = products.some(item => item.alternativeOffer);

      // Alternative total: if no alternative offer exists, return 0; otherwise, calculate normally.
      const alternativeTotal = !hasAlternativeOffer
          ? 0
          : products.reduce((sum, item) => {
            if (item.alternativeOffer) {
              return sum + ((item.alternativeOffer.price + item.alternativeOffer.vatAmount) * item.product.count);
            }
            return sum + ((item.price + item.vatAmount) * item.product.count);
          }, 0);

      const selectedTotal = products.reduce((sum, item) => {
        if (item.alternativeOffer && item.alternativeOffer.isSelected) {
          return sum + ((item.alternativeOffer.price + item.alternativeOffer.vatAmount) * item.product.count);
        } else if (item.isSelected) {
          return sum + ((item.price + item.vatAmount) * item.product.count);
        }
        return sum;
      }, 0);

      return {
        totalMainPrice: parseFloat(mainTotal.toFixed(2)),
        totalAlternativePrice: parseFloat(alternativeTotal.toFixed(2)),
        totalSelectedPrice: parseFloat(selectedTotal.toFixed(2))
      };
    },
    getProductById(id) {

      let prod;
      this.products.forEach(p => {
        if (p.id === parseInt(id)) {
          prod = p;
        }
      })

      return prod;

    },

    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },

    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    exportResultsOnlyPrice(format) {

      exportRequestResultPrice(this.token, this.request.id, format, this.$i18n.locale).then(data => {
        if (data.code === 200) {
          window.open(mediaBase + data.file);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      });
    },
    exportResultsDetailedPrice(format) {

      exportRequestResultDetailed(this.token, this.request.id, format, this.$i18n.locale).then(data => {
        if (data.code === 200) {
          window.open(mediaBase + data.file);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      });

    },

    startConversation(requestUserId) {
      startNewOfferConversation(this.token, this.request.id, requestUserId).then(data => {
        if (data.code === 200) {
          this.$router.push(`/dashboard/conversation/${data.id}`);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }

      });
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}

.offer-container {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.list-unstyled {
  padding-left: 0;
}

.font-weight-bold {
  font-weight: bold;
}

table {
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.custom-row-height {
  max-height: 10px;
}

.bold-row {
  font-weight: bold;
}

hr.dashed {
  border-style: dashed;
  border-color: lightblue;
  border-width: 0.1rem;
}

.file-style {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.badge.bg-danger {
  font-size: 0.9rem;
  padding: 0.3em 0.6em;
  border-radius: 0.5rem;
  color: #fff;
  background-color: #dc3545; /* Red */
}

.badge.bg-primary {
  font-size: 0.9rem;
  padding: 0.3em 0.6em;
  border-radius: 0.5rem;
  color: #fff;
  background-color: #007bff; /* Blue */
}

.table th {
  background-color: #e9ecef;
  color: #333;
  text-align: center;
}

.table td {
  text-align: center;
  vertical-align: middle;
}

.table tbody tr:hover {
  background-color: #f1f1f1;
  cursor: pointer;
}

.table thead th {
  white-space: nowrap;
}

.col-md-6 strong {
  font-size: 1.1rem;
}

.mt-3 strong {
  font-size: 1rem;
  color: #212529;
}

.table-responsive {
  overflow-x: auto;
  max-width: 100%;
}

@media (max-width: 768px) {
  .table {
    font-size: 0.9rem;
  }

  .badge {
    font-size: 0.8rem;
  }
}

.offer-rejected {
  background-color: #f9f9f9; /* Light gray background */
  opacity: 0.6; /* Make it look 'disabled' */
}

/* Additional styles for handling long product names */

/* Apply a fixed layout to the table if needed */
.table-fixed {
  table-layout: fixed;
  width: 100%;
}

/* Style for product name cell */
.product-name {
  width: 200px; /* Adjust width as needed */
  white-space: nowrap;  /* Use nowrap for truncation */
  overflow: hidden;
  text-overflow: ellipsis;
}

/*
For wrapping instead of truncation, use this alternative:
.product-name {
  width: 200px;
  white-space: normal;
  word-wrap: break-word;
}
*/
</style>
